<template>
    <div class="mb-3 pt-8 relative">
        <span class="label-step top-0 left-[-1rem]">1</span>

        <div class="mb-2">
            <h2 class="mb-0 text-[16px]">
                Audience
                <help-tip
                    content="Select 'People' to find your audience at home. Select 'Businesses' to find people where they work."/>
            </h2>
        </div>

        <div>
            <div class="2xl:flex">
                <template v-for="item in audiences">
                    <v-radio v-model="audience"
                             :key="item.key"
                             :value="item.code"
                             class="block mr-10">
                        {{ item.title }}
                    </v-radio>
                </template>
            </div>
            <div class="ml-8">
                <template v-for="item in subAudiences">
                    <v-radio v-model="subAudience"
                             :key="item.key"
                             :value="item.code"
                             class="block">
                        {{ item.title }}
                    </v-radio>
                </template>

                <div class="text-[12px] text-gray-400"
                     v-if="audience === $widgetConfig.b2bBase">
                    Your list will may include multiple contacts for the same company. Try narrowing down your
                    results by Job Title or Job Level.
                </div>

                <template v-if="xPerSelection">
                    <div class="border-t mt-2 pt-2">
                        <div class="flex items-center justify-between w-full mb-2">
                            {{ xPerSelection.title }}
                            <help-tip v-if="xPerSelection.description" :content="xPerSelection.description"/>
                        </div>

                        <radio-list :with-check-icon="false"
                                    :xPerSelection="true"
                                    :item="xPerSelection"/>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import RadioList from "./selections/types/radio-list";
    import xPerSelectionMixin from "../mixins/xPerSelection";

    export default {
        name: "audience",
        components: {
            RadioList
        },
        computed: {
            audience: {
                set (value) {
                    if (!this.selectsNotEmpty) {
                        this.$store.commit("widgetData/setAudience", value);
                    } else {
                        this.$store.commit("others/setConfirmationBase", value);
                        this.$store.commit("others/setLoading", true);
                        this.$store.commit("others/setConfirmationTooltip", true);
                    }
                },
                get () {
                    return this.$store.getters["widgetData/selectedData"].audience;
                }
            },
            subAudience: {
                set (value) {
                    this.$store.commit("widgetData/setSubAudience", value);
                },
                get () {
                    return this.$store.getters["widgetData/selectedData"].subAudience;
                }
            },
            audiences () {
                return this.$store.getters["widgetData/getAudienceData"];
            },
            subAudiences () {
                return this.$store.getters["widgetData/getAudienceChildren"];
            },
            selectsNotEmpty () {
                return this.$store.getters["widgetData/selectedData"].selects.filter(item => !item.code.includes("one_per_address")).length;
            }
        },
        mixins: [
            xPerSelectionMixin
        ],
        watch: {
            audience () {
                this.checkXPerSelection();
            },
            subAudience () {
                this.checkXPerSelection();
            }
        },
        created () {
            this.checkXPerSelection();
        }
    };
</script>
